import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { OrganisationMemberService, SexEnum } from 'src/app/backend';
import { OrgMemberDialogComponent } from 'src/app/shared/dialogs/save-org-member-dialog/save-org-member-dialog.component';
import { UsersService } from '../../backend/api/users.service';
import { BasePagedComponent } from '../../core/components/base-paged/base-paged.component';
import { DialogService } from '../../core/dialog/dialog.service';
import { AuthService } from '../../core/services/auth.service';
import { ConfirmDialogComponent } from '../../shared/dialogs/confirm-dialog/confirm-dialog.component';
import { SaveUserDialogComponent } from '../../shared/dialogs/save-user-dialog/save-user-dialog.component';
import { UntypedFormControl } from '@angular/forms';

interface OrganisationMemeberRow {
  id: number;
  name: string;
  dateOfBirth: any;
  note: string;
  sex: SexEnum;
  joined: any;
  email: string;
  phone: string;
}

@Component({
  selector: 'app-organisation-members',
  templateUrl: './organisation-members.component.html',
  styleUrls: ['./organisation-members.component.scss'],
})
export class OrganisationMembersComponent extends BasePagedComponent implements OnInit {
  data: OrganisationMemeberRow[] = [];
  searchQueryControl = new UntypedFormControl('');
  isLoading = false;

  constructor(
    private dialogService: DialogService,
    private organisationMemberService: OrganisationMemberService,
    private t: TranslateService,
    authService: AuthService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;

    this.organisationMemberService
      .apiOrganisationmemberGet({
        ...this.tableData,
        filter: JSON.stringify({
          search: this.searchQueryControl.value,
        }),
      })
      .subscribe(
        (res) => {
          this.pageLoaded(res);
          this.isLoading = false;
          this.data =
            res.results?.map((x) => ({
              id: x.id || 0,
              name: x.name || '',
              dateOfBirth: moment(x.dateOfBirth).format('MM/DD/YYYY'),
              note: x.note || '',
              sex: x.sex || SexEnum.Female,
              joined: moment(x.joined).format('MM/DD/YYYY'),
              email: x.email || '',
              phone: x.phone || ''
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  getGender(gender?: SexEnum) {
    if (gender === SexEnum.Female) {
      return this.t.instant('female');
    } else if (gender === SexEnum.Male) {
      return this.t.instant('male');
    }

    return '/';
  }

  searchUsers() {
    this.loadData();
  }

  new() {
    this.dialogService
      .open(OrgMemberDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  edit(id: number) {
    this.dialogService
      .open(OrgMemberDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
        data: {
          id,
        },
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  delete(id: number) {
    this.dialogService
      .open(ConfirmDialogComponent, {
        size: 'md',
      })
      .afterClosed.subscribe((res) => {
        if (res?.confirmed) {
          this.organisationMemberService.apiOrganisationmemberIdDelete({ id }).subscribe((res) => {
            this.loadData();
          });
        }
      });
  }
}
